import { createContext, useContext, useState } from "react";

const STORAGE_KEY = "endosmundos_cookie_consent_v1";
const DEFAULT_CONSENT = { necessary: true, analytics: false, marketing: false, affiliate: false };
const CookieConsentContext = createContext(null);

function readConsent() {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    if (stored && stored.version === 1) {
      return {
        necessary: true,
        analytics: stored.analytics === true,
        marketing: stored.marketing === true,
        affiliate: stored.affiliate === true,
      };
    }
  } catch {
    return null;
  }
  return null;
}

export function CookieConsentProvider({ children }) {
  const [initialConsent] = useState(readConsent);
  const [consent, setConsent] = useState(initialConsent || DEFAULT_CONSENT);
  const [hasChoice, setHasChoice] = useState(Boolean(initialConsent));
  const [settingsOpen, setSettingsOpen] = useState(false);

  const saveConsent = (nextConsent) => {
    const saved = {
      version: 1,
      necessary: true,
      analytics: nextConsent.analytics === true,
      marketing: nextConsent.marketing === true,
      affiliate: nextConsent.affiliate === true,
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    } catch {
      // The choice remains active for the current page even if storage is unavailable.
    }
    setConsent(saved);
    setHasChoice(true);
    setSettingsOpen(false);
    if (!saved.affiliate) localStorage.removeItem("endosmundos_affiliate_referral_v1");
  };

  return (
    <CookieConsentContext.Provider value={{ consent, hasChoice, saveConsent, settingsOpen, setSettingsOpen }}>
      {children}
    </CookieConsentContext.Provider>
  );
}

export function useCookieConsent() {
  const context = useContext(CookieConsentContext);
  if (!context) throw new Error("useCookieConsent must be used within CookieConsentProvider");
  return context;
}